export default "__VITE_ASSET__CyLLH9KA__"